export const LANGUAGES = {
  en: "en",
  ar: "ar",
};

export const PHONE_NUMBER_REGEX = /^(010|011|012|015|10|11|12|15)\d{8}$/;
export const NUMBERS_REGEX = /^\d+$/;
